import { render } from "./IconFavorite.vue?vue&type=template&id=3b91966c"
import script from "./IconFavorite.vue?vue&type=script&lang=js"
export * from "./IconFavorite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__